import { render, staticRenderFns } from "./cpsc.vue?vue&type=template&id=3244de49&scoped=true&"
import script from "./cpsc.vue?vue&type=script&lang=js&"
export * from "./cpsc.vue?vue&type=script&lang=js&"
import style0 from "./cpsc.vue?vue&type=style&index=0&id=3244de49&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3244de49",
  null
  
)

export default component.exports